import React from "react";
import { Link } from "react-router-dom";
import { TimelineLite } from "gsap";
import RightArrow from "svgs/RightArrow";
import Arrow from "assets/images/arrow.svg";
import policeImg from "assets/images/police-dep.png";
import PrivacyIcons from "components/privacy-icons";

class RuleFooter extends React.Component {
  render() {
    return (
      <div
        ref={(el) => {
          this.sectionRef = el;
        }}
        className="Main__section"
        style={{
          height: "calc(100vh - 8rem)",
          transform: "translate(0, 8rem)",
        }}
      >
        <div
          className="footer--diffArea"
          ref={(el) => {
            this.div0 = el;
          }}
        >
          <p className="continue">继续浏览</p>
          <Link to="/functionality" className="bigLinkWrapper">
            <p className="bigLink">小米产品中的保护措施</p>
            <img src={Arrow} />
          </Link>

          <p className="continue">了解更多</p>

          <Link to="/functionality" className="littleLinkWrapper">
            <p className="littleLink">我们的产品正在如何保护您的隐私</p>
            <RightArrow width="1.4rem" height="2.5rem" />
          </Link>
          <Link to="/admin-privacy" className="littleLinkWrapper">
            <p className="littleLink">您如何通过我们的产品管理您的隐私</p>
            <RightArrow width="1.4rem" height="2.5rem" />
          </Link>
          <Link to="/protect-methods" className="littleLinkWrapper">
            <p className="littleLink">小米通过哪些保护措施确保您的隐私安全</p>
            <RightArrow width="1.4rem" height="2.5rem" />
          </Link>
          <a
            href="https://trust.mi.com/zh-CN"
            target="_blank"
            rel="noopener noreferrer"
            className="littleLinkWrapper"
          >
            <p className="littleLink">阅览《安全与隐私白皮书》</p>
            <RightArrow width="1.4rem" height="2.5rem" />
          </a>
          <a
            href="https://privacy.mi.com/all/zh_CN/"
            target="_blank"
            rel="noopener noreferrer"
            className="littleLinkWrapper"
          >
            <p className="littleLink">阅览我们的隐私政策</p>
            <RightArrow width="1.4rem" height="2.5rem" />
          </a>
          {/* <a href="https://www.xiaomi.cn/" className="goTo">
            <img src={community} className="logo" />
            <div className="littleLinkWrapper noMargin">
              <p className="littleLink">和小米社区的朋友们聊聊如何保护隐私</p>
              <LittleArrow />
            </div>
          </a> */}
        </div>
        <footer className="footer">
          <div
            style={{ marginBottom: "5rem" }}
            ref={(el) => {
              this.div1 = el;
            }}
          >
            <p className="title">我们的隐私保护能力和措施</p>
            <p className="title">通过业界权威的隐私保护认证和测试</p>
          </div>

          <div style={{ marginBottom: "6rem" }}>
            <PrivacyIcons />
          </div>
          <div style={{ marginBottom: "6rem" }}>
            <p className="statement">说明和免责声明：</p>
            <p className="statement">
              -
              本站中所展示的功能界面仅供参考，实际呈现效果以线上所提供的版本为准；我们也将不断更新和优化我们的功能和服务，不再另做说明
            </p>
            <p className="statement">
              -
              本站中所披露的相关信息仅适用于小米手机系统及部分互联网应用，小米其他相关产品（如智能硬件、小米电视等）的隐私保护措施请您参阅各产品的相关说明
            </p>
            <p className="statement">
              - 本站中所披露的相关信息适用于 MIUI 12 及以上版本的小米手机及
              Redmi 手机系统，部分内容适用于 MIUI 10 及以上版本的小米手机及
              Redmi 手机系统
            </p>
            <p className="statement">
              - 本站中所披露的相关信息如与《小米隐私政策》不一致时，以
              <a
                href="https://privacy.mi.com/all/zh_CN/"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  cursor: "pointer",
                  color: "#04a0ff",
                  textDecoration: "none",
                }}
              >
                《小米隐私政策》
              </a>
              所述信息为准
            </p>
            <p className="statement">
              -
              小米有权对各产品和服务的隐私保护措施进行调整，我们将会在调整后及时更新对应产品和服务的隐私政策。如与本站所披露的内容不一致时，以各产品和服务的最新隐私政策为准，本站将不再另做说明
            </p>
            <p className="statement">
              -
              部分产品和服务的隐私保护措施仅适用于中国大陆地区，其他国家和地区的相关信息请参阅我们在当地销售的产品中的隐私政策
            </p>
          </div>
          <div className="veryBottom">
            <div>
              <p>
                您对我们的隐私政策或措施有任何建议和意见，请与我们的
                <a
                  href="https://privacy.mi.com/support/contact"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    cursor: "pointer",
                    color: "#04a0ff",
                    textDecoration: "none",
                  }}
                >
                  数据保护官
                </a>
                取得联系
              </p>

              <p style={{ position: "relative" }}>
                © mi.com 京ICP备10046444号 |{" "}
                <img
                  src={policeImg}
                  style={{
                    width: "12px",
                    height: "12px",
                    position: "absolute",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                />
                京公网安备11010802037409号 | 京ICP证110507号
              </p>
            </div>
          </div>
        </footer>
      </div>
    );
  }

  componentDidMount() {
    const { tlCompleteCallback, tlReverseCompleteCallback } = this.props;
    this.tl = new TimelineLite({
      paused: true,
      onComplete: tlCompleteCallback,
      onReverseComplete: tlReverseCompleteCallback,
    });
    // this.tl.fromTo(
    //   this.sectionRef,
    //   0.6,
    //   { autoAlpha: 1 },
    //   {
    //     autoAlpha: 0,
    //   }
    // );
    this.tl
      // .fromTo(
      //   this.div2,
      //   0.4,
      //   { autoAlpha: 1, y: 0 },
      //   {
      //     autoAlpha: 0,
      //     y: '6rem',
      //   }
      // )
      .fromTo(
        this.div1,
        0.4,
        { autoAlpha: 1, y: 0 },
        {
          autoAlpha: 0,
          y: "6rem",
        },
        "-=0.2"
      )
      .fromTo(
        this.div0,
        0.4,
        { autoAlpha: 1, y: 0 },
        {
          autoAlpha: 0,
          y: "6rem",
        },
        "-=0.2"
      )
      .set(this.sectionRef, {
        autoAlpha: 0,
      });
    this.tl.progress(1, true).pause();
  }
}

export default RuleFooter;
